import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getRequest } from "../../utils/api";
import { toast } from "react-toastify";
import { logout } from "../../utils/auth";
import moment from "moment";
import PaginationComponent from "../../Component/Pagination/pagination";

const PaymentHistory = () => {
    const [isLoader, setIsLoader] = useState<any>(true);
    const [transList, setTransList] = useState<any[]>([]);
    const [page, setPage] = useState<number>(1);

    const [totalPages, setTotalPages] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);


    const getTransactionList = useCallback(async (currentPage: number) => {
        try {
            setIsLoader(true)
            const response = await getRequest(`/payment-history/transactionList?page=${currentPage}&activeTab=All`);
            if (response.status === 'success') {
                setTransList(response.data as any[])
                setIsLoader(false);
                setTotalPages(response.pagination.totalPages);
                setTotalRecords(response.pagination.totalRecords);
            }
            else if (response.status == 'session_expired') {
                setIsLoader(false)
                logout()
            }
            else {
                setIsLoader(false)
                toast.error(response.message);
            }
        } catch (error) {
            setIsLoader(false)
            toast.error("Something went wrong!");
        }
    }, []);

    const isFirstRender = useRef(false); // Track first render
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = true; // Skip first render
            return;
        }
        getTransactionList(page);
    }, [page]);

    return (
        <div className="hk-pg-wrapper">
            <div className="hk-pg-body py-0">
                <div className="page-wrap">
                    <div className="page-content ps-0">
                        <div className="page-detail-wrap">
                            <header className="page-header">
                                <div>
                                    <div className="page-title">
                                        <h2 className="mb-0">Payment History</h2>
                                    </div>
                                </div>
                                <div className="page-options-wrap">

                                    <div className="v-separator d-lg-inline-block d-none"></div>


                                    <a className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover hk-navbar-togglable d-lg-inline-block d-none"
                                        href="#" data-bs-toggle="tooltip" data-bs-placement="top" title=""
                                        data-bs-original-title="Collapse">
                                        <span className="btn-icon-wrap">
                                            <span className="feather-icon"><i className="ri-arrow-up-s-line ri-lg"></i></span>
                                            <span className="feather-icon d-none"><i className="ri-arrow-down-s-line ri-lg"></i></span>
                                        </span>
                                    </a>
                                </div>
                            </header>
                            <div className="page-body">
                                <div data-simplebar className="nicescroll-bar">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="card">
                                                    <div className="table-responsive">
                                                        <table className="table table-hover mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th>Invoice ID</th>
                                                                    <th>Transaction ID</th>
                                                                    <th>Customer Details</th>
                                                                    <th>Amount</th>
                                                                    <th className="text-center">Payment Mode</th>
                                                                    <th className="text-center">Status</th>
                                                                    <th>Create Date</th>
                                                                    <th className="text-center">Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {transList && transList.length > 0 ? (
                                                                    transList.map((item, index) => (
                                                                        <tr>
                                                                            <td><a href="#" className="fw-bold">#{item.transaction_order_id}</a></td>
                                                                            <td><a href="#" className="fw-bold">#{item.transaction_order_id}</a></td>
                                                                            <td>
                                                                                <div className="media align-items-center">
                                                                                    <div className="media-head me-2">
                                                                                        <div className="avatar avatar-xs rounded">
                                                                                            <img src="dist/img/logo-avatar-3.png" alt="user" className="avatar-img" />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="media-body">
                                                                                        <h6 className="fs-14 mb-0">{item.transaction_user_id?.user_first_name ?? "–"} {item.transaction_user_id?.user_last_name ?? "–"}</h6>
                                                                                        <p className="mb-0 fs-12">{item.transaction_formdata?.email ?? "–"}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td><span className="fw-bold">₹{Number(item.transaction_amount).toFixed(2) ?? "0.00"}</span></td>
                                                                            <td className="text-center"><a href="#" className="fw-bold text-uppercase">{item?.method ?? "–"}</a></td>

                                                                            <td className="text-center"><span className={item.status == "success" ? "badge bg-success"
                                                                                : item.status == "panding" ? "badge bg-warning" : "badge bg-danger"
                                                                            }>{item.status}</span></td>

                                                                            <td className="text-center">{moment(item.createdAt).format('DD MMM, YYYY')}</td>
                                                                            <td className="text-center"></td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={10}>
                                                                            <div className="text-center">No Record Found</div>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="card-footer d-flex justify-content-between align-items-center">
                                                        <div className="col-sm">
                                                            <div className="text-muted">Showing <span className="fw-semibold">{transList?.length || 0}</span> of <span className="fw-semibold">{totalRecords || 0}</span> Results</div>
                                                        </div>
                                                        {totalPages > 0 && <PaginationComponent totalPages={totalPages} currentPage={page} setCurrentPage={setPage} />}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default PaymentHistory